import React from "react";

import logo from "./../../logo_black.svg";

export const MessagePage = ({ message }: { message: string }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="max-w-md w-full py-4 px-6">
        <img className="mx-auto h-20 w-auto my-8" src={logo} alt="" />
        <div className="relative flex justify-center text-sm leading-5">
          <span className="px-2 bg-gray-100 font-bold text-gray-500">
            {message}
          </span>
        </div>
      </div>
    </div>
  );
};
